"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImportKitchenCounter = exports.useUpdateKitchenCounter = exports.useCreateKitchenCounter = exports.useFetchKitchenCounters = void 0;
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const kitchenCountersAction_1 = require("./kitchenCountersAction");
const useFetchKitchenCounters = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const kitchenCountersLoading = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/fetch"].loading);
    const kitchenCountersError = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/fetch"].error);
    const kitchenCountersData = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/fetch"].data);
    const kitchenCountersFetch = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLoggedIn) {
            history("/auth/sign-in");
            return;
        }
        yield dispatch((0, kitchenCountersAction_1.fetch)(payload));
    });
    return {
        kitchenCountersLoading,
        kitchenCountersError,
        kitchenCountersData,
        kitchenCountersFetch
    };
};
exports.useFetchKitchenCounters = useFetchKitchenCounters;
const useCreateKitchenCounter = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const kitchenCountersLoading = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/create"].loading);
    const kitchenCountersError = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/create"].error);
    const kitchenCountersData = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/create"].data);
    const kitchenCountersCreate = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history("/auth/sign-in");
                return;
            }
            const res = yield dispatch((0, kitchenCountersAction_1.create)(payload));
            if (res.meta.requestStatus === "fulfilled") {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === "rejected") {
                throw new Error("Error while creating kitchen counter");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        kitchenCountersLoading,
        kitchenCountersError,
        kitchenCountersData,
        kitchenCountersCreate
    };
};
exports.useCreateKitchenCounter = useCreateKitchenCounter;
const useUpdateKitchenCounter = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const kitchenCountersLoading = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/update"].loading);
    const kitchenCountersError = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/update"].error);
    const kitchenCountersData = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/update"].data);
    const kitchenCountersUpdate = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history("/auth/sign-in");
                return;
            }
            const res = yield dispatch((0, kitchenCountersAction_1.update)(payload));
            if (res.meta.requestStatus === "fulfilled") {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === "rejected") {
                throw new Error("Error while updating kitchen counter");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        kitchenCountersLoading,
        kitchenCountersError,
        kitchenCountersData,
        kitchenCountersUpdate
    };
};
exports.useUpdateKitchenCounter = useUpdateKitchenCounter;
const useImportKitchenCounter = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const kitchenCountersLoading = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/import"].loading);
    const kitchenCountersError = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/import"].error);
    const kitchenCountersData = (0, react_redux_1.useSelector)((state) => state["kitchenCounters/import"].data);
    const kitchenCountersImport = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history("/auth/sign-in");
                return;
            }
            const res = yield dispatch((0, kitchenCountersAction_1.importKitchenCounters)(payload));
            if (res.meta.requestStatus === "fulfilled") {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === "rejected") {
                throw new Error("Error while importing kitchen counter");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        kitchenCountersLoading,
        kitchenCountersError,
        kitchenCountersData,
        kitchenCountersImport
    };
};
exports.useImportKitchenCounter = useImportKitchenCounter;
